import * as React from 'react';

import NoEntities from '../../../../shared/NoEntities';

const NoInvoices: React.FunctionComponent = () => {
  return <NoEntities>お支払い履歴はありません</NoEntities>;
};

export default React.memo(NoInvoices);
